
<template>
  <div class="banner">
    <img
      src="@/assets/solution/enterprise/solution_banner.png"
      alt=""
    >
    <div class="banner_Title">
      <div class="title">
        {{ title }}
      </div>
      <div class="subtitle">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String },
    subtitle: { type: String }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100wh;
  height: 550px;

  img {
    width: 100%;
    height: 100%;
  }

  .banner_Title {
    position: absolute;
    top: 15%;
    left: 15%;
    width: 80%;

    .title {
      width: 56%;
      font-size: 54px;
      color: #ffffff;
      font-weight: bold;
    }

    .subtitle {
      width: 80%;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-top: 50px;
    }
  }
}

@media (max-width: 750px)and (max-width: 1250px) {
  .banner .banner_Title .title {
    width: 74% !important;
  }

  .page_html .banner .banner_Title .title {
    font-size: 30px !important;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .banner .banner_Title .title {
    width: 74% !important;
    font-size: 37px !important;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 20px;
  }

  .banner{
    height: 400px !important;
  }

}

@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .banner .banner_Title .title {
    width: 74% !important;
    font-size: 40px;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 25px;
  }

  .banner{
    height: 450px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .banner .banner_Title .title {
    width: 90% !important;
    font-size: 52px;
  }

   .banner .banner_Title .subtitle {
    font-size: 30px;
  }

}
</style>
